import {
  TextInput,
  DateInput,
  SelectInput,
  BooleanInput,
  FormDataConsumer,
  ArrayInput,
  SimpleFormIterator,
  required,
} from "react-admin";
import Typography from "@mui/material/Typography";
import NoArrowKeyNumberInput from "@/components/NoArrowKeyNumberInput";
import { EVENT_TYPE_CHOICES } from "@/constants";
import { EventSequenceFields } from "./EventSequenceFields";
import { EventRelayEventField } from "./EventRelayEventField";

const venueRoleChoices = [
  { id: "JAMAN", name: "Jaman venue" },
  { id: "NAMAAZ", name: "Namaaz venue" },
];

export const EventFormFields = () => (
  <>
    <TextInput source="name" fullWidth validate={required()} />
    <DateInput source="fromDate" fullWidth validate={required()} />
    <DateInput source="toDate" fullWidth validate={required()} />
    <TextInput
      source="hijriYear"
      fullWidth
      validate={required()}
      helperText="Hijri year (e.g., 1445)"
    />
    <TextInput
      source="slug"
      fullWidth
      validate={required()}
      helperText="URL-friendly identifier (e.g., ashara-mubaraka-1445)"
    />
    <SelectInput
      source="type"
      label="Event type"
      choices={EVENT_TYPE_CHOICES}
      fullWidth
      validate={required()}
      defaultValue="SHEHRULLA"
    />
    <BooleanInput source="rsvpEnabled" label="Event RSVP enabled" defaultValue fullWidth />
    <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1, mb: 0.5 }}>
      Venues
    </Typography>
    <ArrayInput source="venues" label={false}>
      <SimpleFormIterator inline>
        <TextInput source="code" label="Code" helperText="Short code (e.g. FM)" />
        <TextInput source="label" label="Label" helperText="Display name" />
        <SelectInput source="role" label="Role" choices={venueRoleChoices} />
        <NoArrowKeyNumberInput source="sortOrder" label="Sort order" defaultValue={0} />
      </SimpleFormIterator>
    </ArrayInput>

    <EventSequenceFields />

    <FormDataConsumer>
      {({ formData }) => {
        const isAshara = formData?.type === "ASHARA";
        return (
          <>
            <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1, mb: 0.5 }}>
              Unit amounts (₹)
            </Typography>
            <NoArrowKeyNumberInput
              source="zabihatAmount"
              label="Zabihat amount"
              fullWidth
              helperText="Amount per zabihat unit"
            />
            <NoArrowKeyNumberInput
              source="chairAmount"
              label="Chair amount"
              fullWidth
              helperText="Amount per chair"
            />
            <NoArrowKeyNumberInput
              source="pirsaAmount"
              label="Pirsa amount"
              fullWidth
              helperText="Amount per pirsa unit"
            />
            {isAshara && (
              <>
                <EventRelayEventField />
                <NoArrowKeyNumberInput
                  source="mehmaanAmount"
                  label="Mehmaan amount"
                  fullWidth
                  helperText="Amount per mehmaan"
                />
                <NoArrowKeyNumberInput
                  source="relayAmount"
                  label="Relay amount"
                  fullWidth
                  helperText="Amount per relay access unit"
                />
              </>
            )}
          </>
        );
      }}
    </FormDataConsumer>
  </>
);
